export default __webpack_public_path__ + "static/media/bubbles.77116b47.png";